<ng-template #whatsNewTemplate>
    <div class="whatsnew-popover max-vh-80 overflow-x-hidden overflow-y-scroll">
        @for (update of newUpdates$ | async; track update; let last = $last) {
            <div class="row">
                <div
                    class="col py-2 whatsnew-item cursor-pointer"
                    (click)="onUpdateClick(update); pop.hide()"
                    [ngClass]="{
                        'cancelled-text': update.isMessageTypeCancelled(),
                        'link-text': isUpdateTypeLink(update),
                        'border-bottom': !last,
                    }"
                >
                    @if (!isUpdateTypeLink(update) && !update.isMessageTypeCancelled()) {
                        <fa-icon [icon]="faInfoCircle"></fa-icon>
                    }
                    @if (update.isMessageTypeCancelled()) {
                        <fa-icon [icon]="faBan"></fa-icon>
                    }
                    {{ update.message }}
                    @if (displayNotificationNumber) {
                        <span>({{ update.notificationId.qmNum }})</span>
                    }
                </div>
            </div>
        }
    </div>
</ng-template>

<div
    [popover]="(newUpdates$ | async)?.length > 0 && whatsNewTemplate"
    [outsideClick]="true"
    placement="bottom"
    #pop="bs-popover"
    class="d-flex align-items-center gap-1 pe-lg-0 pe-3 cursor-pointer"
>
    <fa-icon [icon]="faEnvelope" size="lg"></fa-icon>
    <span class="d-none d-lg-block" translate="APP_HEADER_NEW_UPDATES_TITLE"></span>
    @if ((newUpdates$ | async)?.length > 0) {
        <span class="badge rounded-pill bg-primary" [ngClass]="{ cancelled: getCancelledUpdatesCount() > 0 }">
            {{ (newUpdates$ | async)?.length }}</span
        >
    }
</div>
